import { render, staticRenderFns } from "./WorkTable981.vue?vue&type=template&id=5ecdf4e6&scoped=true"
import script from "./WorkTable981.vue?vue&type=script&lang=js"
export * from "./WorkTable981.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecdf4e6",
  null
  
)

export default component.exports